export const LOREN_ROUTER_OUTLETS  = {
    LOGIN: 'login-router-outlet',
    DETAILS: 'details'
};
